import { render, staticRenderFns } from "./newsVol.vue?vue&type=template&id=7e9cea7f&scoped=true&"
import script from "./newsVol.vue?vue&type=script&lang=js&"
export * from "./newsVol.vue?vue&type=script&lang=js&"
import style0 from "./newsVol.vue?vue&type=style&index=0&id=7e9cea7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9cea7f",
  null
  
)

export default component.exports